<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Webhooks</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-skeleton-loader class="mt-5" v-if="$store.state.accounts.retrieveLoader" transition="fade-transition" type="table" />
          <template v-else>
            <template v-if="webhooksList.length">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Estado</th>
                      <th>URL</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="d in webhooksList">
                      <tr @click="$router.push({ name: 'AccountSettingsWebhooksRetrieveUpdate', params: { id: d.id } })" :key="d.id">
                        <td>
                          <v-chip v-if="d.status === 'enabled'" color="lightBlue" small text-color="primary">Habilitado</v-chip>
                          <v-chip v-else-if="d.status === 'disabled'" color="defaultGrey" small text-color="secondary">Deshabilitado</v-chip>
                        </td>
                        <td>
                          <span class="text--secondary font-weight-medium">{{d.url}}</span>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
              <v-divider />
              <v-col md="12" class="text-center py-5">
                <v-btn @click="dialogCreate=true" outlined color="secondary"><v-icon left>mdi-plus</v-icon> Nuevo webhook</v-btn>
              </v-col>
            </template>
            <v-row class="mx-0" v-else>
              <v-col class="py-5 text-center">
                <v-icon class="d-block" color="secondary" size="70">mdi-call-split</v-icon>
                <span class="d-block subtitle-1 my-2">Aún no tienes webhooks</span>
                <v-btn @click="dialogCreate=true" outlined color="secondary"><v-icon left>mdi-plus</v-icon> Nuevo webhook</v-btn>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialog new webhook -->
    <v-dialog v-model="dialogCreate" width="800" persistent no-click-animation>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Crear un nuevo webhook</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="pr-1">
              <v-btn icon retain-focus-on-click :ripple="false" small @click="dialogCreate=false"><v-icon small>mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background-card">
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-2">
              <v-list-item-title>URL de conexión</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="$v.newWebhook.url.$model" :error="$v.newWebhook.url.$error" placeholder="Ej: https://webhooks.myproduct.com/piriod/" background-color="white" outlined required single-line dense hide-details />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-2">
              <v-list-item-title>Descripción</v-list-item-title>
              <v-list-item-subtitle>
                <v-text-field v-model="$v.newWebhook.description.$model" :error="$v.newWebhook.description.$error" background-color="white" outlined required single-line dense hide-details />
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
          <v-divider />
          <v-list class="v-list-form py-6 transparent">
            <v-list-item class="py-2">
              <v-list-item-title>
                <span class="d-block">Eventos</span>
                <v-btn class="my-1" :href="`${$DOCS_BASE}${guides[0]}`" target="_blank" text color="primary" :ripple="false" small>Aprende más sobre los eventos</v-btn>
              </v-list-item-title>
              <v-list-item-subtitle>
                <v-row class="mx-0">
                  <v-col cols="8">
                    <v-select v-model="$v.newWebhook.events.$model" :error="$v.newWebhook.events.$error" :items="eventsList" label="Seleccionar eventos" item-value="name" item-text="name" background-color="white" outlined solo flat dense multiple hide-details>
                      <template v-slot:selection="{ index }">
                        <span class="mx-1" v-if="index === 0">Seleccionar eventos</span>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col class="text-right" cols="4">
                    <v-btn class="my-1" @click="newWebhook.events = []" text color="primary" :ripple="false">Limpiar</v-btn>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title></v-list-item-title>
              <v-list-item-subtitle>
                <v-card class="mx-1" outlined height="189px" style="overflow: scroll;">
                  <v-card-text class="pa-0">
                    <v-list class="v-list-form py-0" dense v-if="newWebhook.events.length">
                      <template v-for="(d, i) in newWebhook.events">
                        <v-list-item class="py-0 my-0" :key="`${i}-item`">
                          <v-list-item-title>{{d}}</v-list-item-title>
                          <v-list-item-action class="ma-0 text-right">
                            <v-btn @click="newWebhook.events.splice(i, 1)" text color="primary" :ripple="false" small><v-icon right small>mdi-close</v-icon></v-btn>
                          </v-list-item-action>
                        </v-list-item>
                        <v-divider :key="`${i}-divider`" />
                      </template>
                    </v-list>
                    <v-col class="text-center py-14 px-6" v-else>
                      <span class="d-block text--secondary subtitle-1 font-weight-medium">Sin eventos seleccionados.</span>
                      <span class="d-block body-2">Usa el menú desplegable de arriba para buscar y seleccionar los eventos.</span>
                    </v-col>
                  </v-card-text>
                </v-card>
                <span class="d-block mx-1 py-1 text--secondary body-2">{{newWebhook.events.length}} eventos</span>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogCreate=false" outlined>Cancelar</v-btn>
          <v-btn @click="postWebhook" :loading="$store.state.accounts.createLoader" color="primary">Crear webhook</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog new webhook -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength, url } from 'vuelidate/lib/validators'
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    newWebhook: {
      description: '',
      events: [],
      url: ''
    },
    guides: [
      '/docs/webhooks#eventos-disponibles'
    ],
    dialogCreate: false
  }),
  computed: mapState({
    eventsList: state => state.accounts.eventsList,
    webhooksList: state => state.accounts.webhooksList
  }),
  created () {
    this.$store.dispatch('accounts/LIST', {
      resource: 'events',
      params: {
        page_size: 100
      }
    })
    this.$store.dispatch('accounts/LIST', {
      resource: 'webhooks'
    })
  },
  methods: {
    postWebhook () {
      this.$v.newWebhook.$touch()
      if (this.$v.newWebhook.$invalid) {
        return false
      }
      this.$store.dispatch('accounts/CREATE', {
        resource: 'webhooks',
        payload: this.newWebhook
      })
      .then((response) => {
        this.$router.push({
          name: 'AccountSettingsWebhooksRetrieveUpdate',
          params: {
            id: response.data.id
          }
        })
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    toggleSelectedEvents () {
      this.$nextTick(() => {
        if (this.allEventsSelected) {
          this.newWebhook.events = []
        } else {
          this.newWebhook.events = this.eventsList.slice()
        }
      })
    }
  },
  validations: {
    newWebhook: {
      description: {
        maxLength: maxLength(512)
      },
      events: {
        required
      },
      url: {
        required,
        url
      }
    }
  }
}
</script>